import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function AddRow(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 -1 24 24" {...props}>
      <path d="M11 13h2v3h3v2h-3v3h-2v-3H8v-2h3v-3zm11-4a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h16a2 2 0 012 2v3M4 9h4V6H4v3m6 0h4V6h-4v3m6 0h4V6h-4v3z" />
    </SvgIcon>
  );
}
